import React from "react";
// import Common Banner
import CommonBanner from "../component/Common/CommonBanner";
// import AboutArea
import AboutArea from "../component/About/AboutArea";
// import DiscountArea
import DiscountArea from "../component/About/DiscountArea";
// import AboutServices
import AboutServices from "../component/About/Services";
// import Consultation
import Consultation from "../component/About/Consultation";
// import Counter
import Counter from "../component/About/Counter";
// import CustomerReview
import CustomerReview from "../component/About/CustomerReview";
import { ImageConstants } from "../assets/img/ImageConstants";
import VideoAreaTwo from "../component/BecomeExpert/VideoAreaTwo";
import { Helmet } from "react-helmet-async";
const About = () => {
  return (
    <>
        <Helmet>
                <title>Polani Travels | Home</title>
        <meta name="description" content="Zain" />
        <meta name="keywords" content="travel packages, tours, polani" />
        <meta property="og:title" content="Polani Travels | About" />
        <meta
          property="og:description"
          content="Your page specific description"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      {/* <CommonBanner heading="About us" pagination="About" /> */}
      <CommonBanner
        heading="About us"
        img={ImageConstants.aboutusheadbanner}    
        pagination="About"
      />
      <AboutArea />
      {/* <DiscountArea /> */}
      <DiscountArea
        smallImg={ImageConstants.aboutussmallimg}
        largeImg={ImageConstants.aboutuslargee}
      />
      {/* <VideoAreaTwo style={{ paddingTop: '0px!important'}} /> */}
      <AboutServices />
      <Consultation />
      <Counter />
      <CustomerReview />
    </>
  );
};

export default About;
